import { cn } from '@discover-lib/utils';
import Button, { type ButtonProps } from '@discover-ui/button';
import ChevronDownIcon from '@discover-ui/icons/chevron-down.svg';

export type MapCloseButtonProps = ButtonProps;

export default function MapCloseButton({
  className,
  kind = 'link',
  ...props
}: MapCloseButtonProps) {
  return (
    <Button
      kind={kind}
      className={cn(
        'flex w-full items-center justify-center rounded-none rounded-t-lg bg-gray-50',
        className
      )}
      aria-label="restaurant map close"
      {...props}>
      <ChevronDownIcon className="size-6 text-gray-200" />
    </Button>
  );
}
